import { atomWithStorage } from "jotai/utils"

// 广告显示记录接口
export interface AdvertisementRecord {
	id: string
	area: string // 地区信息，用于地区隔离
	lastShown: number // 显示过的时间戳
	contentHash?: string // 广告内容哈希，用于检测广告是否已更新
}

// 广告状态存储
export const advertisementRecordsAtom = atomWithStorage<
	Record<string, AdvertisementRecord>
>("advertisement_records", {}, undefined, {
	getOnInit: false, // 禁用自动初始化
})
